import axios from "axios";
import { useState, useContext } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../../assets/css/delivery/auth/DeliveryAuth.css";
import MyContext from "../../../context/MyContext";

// ── inline error styles — jab tak DeliveryAuth.css mein dedicated
// error classes nahi ban jatin, red border/message ye reuse karte hain ──
// ── Pakistan Cities — DeliverySettings.jsx wali hi list, consistency
// ke liye (register time pe select ki hui city same-city/intercity
// matching mein use hoti hai) ──
const PAKISTAN_CITIES = [
  "Abbottabad", "Attock", "Bahawalpur", "Bahawalnagar", "Burewala", "Chakwal",
  "Chiniot", "Chishtian", "Daska", "Dera Ghazi Khan", "Dera Ismail Khan",
  "Faisalabad", "Ghotki", "Gujranwala", "Gujrat", "Hafizabad", "Haripur",
  "Hyderabad", "Islamabad", "Jacobabad", "Jhelum", "Kamoke", "Karachi",
  "Kasur", "Khanewal", "Khushab", "Khuzdar", "Lahore", "Larkana", "Layyah",
  "Lodhran", "Mailsi", "Mansehra", "Mardan", "Mianwali", "Mirpur Khas",
  "Multan", "Muridke", "Muzaffarabad", "Muzaffargarh", "Narowal", "Nawabshah",
  "Nowshera", "Okara", "Pakpattan", "Peshawar", "Quetta", "Rahim Yar Khan",
  "Rawalpindi", "Sadiqabad", "Sahiwal", "Sargodha", "Sheikhupura", "Sialkot",
  "Sukkur", "Swabi", "Swat", "Toba Tek Singh", "Vehari", "Wah Cantonment",
  "Wazirabad",
].sort();

const errBorder = { borderColor: "#dc3545" };
const errText = { color: "#dc3545", fontSize: 12, marginTop: 4, marginBottom: 8 };

const DeliveryRegister = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // ── NEW: field-level errors — separate useState per field ──
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [cityError, setCityError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPassError, setConfirmPassError] = useState("");

  const { baseUrl, regExpChecker, setAuthToken, setLoggedInDeliveryMan } = useContext(MyContext);
  const navigate = useNavigate();

  // NEW: register ab 2-step ho gaya hai — pehle OTP jata hai
  // (sendRegisterOtp), phir OTP verify hone ke baad account banta
  // hai (verifyRegisterOtp). step 1 = form, step 2 = OTP.
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [resending, setResending] = useState(false);

  // ── NEW: pura form validate karta hai, saari fields ke liye
  // regExpChecker (MyContext) use karke — jo already project mein
  // login/settings forms ke liye use ho raha hai ──
  // ── FIXED: address aur confirmPass ke validation blocks yahan se
  // hataye gaye hain, kyunke UI mein in dono ka koi input field hi
  // nahi hai. Pehle inke states (address, confirmPass) hamesha empty
  // rehte thay, is liye validateForm() hamesha false return karta
  // tha aur "Send Verification Code" button kabhi kaam hi nahi karta
  // tha (silently return ho jata tha) — form kitna bhi sahi bhara ho ──
  const validateForm = () => {
    let valid = true;

    const nameErr = regExpChecker("username", name);
    if (!name) {
      setNameError("Full name is required");
      valid = false;
    } else if (nameErr) {
      setNameError(nameErr);
      valid = false;
    } else setNameError("");

    const emailErr = regExpChecker("email", email);
    if (!email) {
      setEmailError("Email is required");
      valid = false;
    } else if (emailErr) {
      setEmailError(emailErr);
      valid = false;
    } else setEmailError("");

    const phoneErr = regExpChecker("phoneNumber", phone);
    if (!phone) {
      setPhoneError("Phone number is required");
      valid = false;
    } else if (phoneErr) {
      setPhoneError(phoneErr);
      valid = false;
    } else setPhoneError("");

    if (!city) {
      setCityError("Please select your city");
      valid = false;
    } else setCityError("");

    const passErr = regExpChecker("password", password);
    if (!password) {
      setPasswordError("Password is required");
      valid = false;
    } else if (passErr) {
      setPasswordError(passErr);
      valid = false;
    } else setPasswordError("");

    return valid;
  };

  const sendRegisterOtp = ({ isResend = false } = {}) => {
    if (!isResend && !validateForm()) return;

    setErrorMessage("");
    isResend ? setResending(true) : setLoading(true);

    const formdata = new FormData();
    formdata.append("name", name);
    formdata.append("email", email);
    formdata.append("phone", phone);
    formdata.append("address", address);
    formdata.append("city", city);
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/delivery/auth/sendRegisterOtp`, formdata)
      .then((response) => {
        isResend ? setResending(false) : setLoading(false);
        const data = response.data;
        if (data.success) {
          Swal.fire(
            "Sent!",
            isResend
              ? "A new verification code has been sent to your email."
              : "A verification code has been sent to your email.",
            "success"
          );
          setStep(2);
        } else {
          setErrorMessage(data.message || "Registration failed. Please try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        isResend ? setResending(false) : setLoading(false);
        setErrorMessage("Registration failed. Please try again.");
      });
  };

  const resendOtp = () => {
    sendRegisterOtp({ isResend: true });
  };

  const verifyRegisterOtp = () => {
    if (!otp) {
      setOtpError("Please enter the code sent to your email");
      return;
    }

    setOtpError("");
    setErrorMessage("");
    setLoading(true);

    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("otp", otp);

    axios
      .post(`${baseUrl}/delivery/auth/verifyRegisterOtp`, formdata)
      .then((response) => {
        const data = response.data;
        if (data.success) {
          console.log("Registration successful", data);
          localStorage.setItem("deliveryPhone", phone);
          localStorage.setItem("deliveryPassword", password);
          // backend register response mein token + deliveryman deta
          // hai — auto-login karke seedha Open Jobs pe le jate hain
          localStorage.setItem("authToken", data.token);
          setAuthToken(data.token);
          localStorage.setItem(
            "loggedInDeliveryMan",
            JSON.stringify(data.deliveryman),
          );
          setLoggedInDeliveryMan(data.deliveryman);
          navigate("/delivery/open-jobs");
        } else {
          setLoading(false);
          setOtpError(data.message || "Invalid OTP. Please try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        setOtpError("Something went wrong. Please try again.");
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (step === 1) {
      sendRegisterOtp();
    } else {
      verifyRegisterOtp();
    }
  };

  return (
    <div className="delivery-auth-wrapper">
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ width: "4rem", height: "4rem" }}
          />
          <p style={{ marginTop: "15px", fontSize: "18px" }}>
            {step === 1 ? "Sending verification code..." : "Verifying..."}
          </p>
        </div>
      ) : (
        <div className="delivery-auth-container">
          <div className="delivery-auth-card">
            {/* Logo */}
            <div className="delivery-auth-logo">
              <div className="delivery-logo-icon">🚜</div>
            </div>

            {/* Header */}
            <div className="delivery-auth-header">
              <h1 className="delivery-auth-title">Create Delivery Account</h1>
              <p className="delivery-auth-subtitle">
                {step === 1
                  ? "We'll email you a code to verify it's really you."
                  : `We've sent a 6-digit code to ${email}.`}
              </p>
              <p className="delivery-auth-subtitle">
                Already have an account?{" "}
                <Link to="/delivery/login" className="delivery-auth-link">
                  Login here
                </Link>
              </p>
            </div>

            <Form onSubmit={handleSubmit} className="delivery-minimal-form">
              {step === 1 ? (
                <>
                  {/* Full Name */}
                  <div className="delivery-form-group">
                    <Form.Control
                      type="text"
                      placeholder="Full name"
                      value={name}
                      style={nameError ? errBorder : undefined}
                      onChange={(e) => {
                        setName(e.target.value);
                        setNameError(e.target.value ? (regExpChecker("username", e.target.value) || "") : "Full name is required");
                      }}
                      className="delivery-minimal-input"
                    />
                    {nameError && <p style={errText}>{nameError}</p>}
                  </div>

                  {/* Email */}
                  <div className="delivery-form-group">
                    <Form.Control
                      type="email"
                      placeholder="Email address"
                      value={email}
                      style={emailError ? errBorder : undefined}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setEmailError(e.target.value ? (regExpChecker("email", e.target.value) || "") : "Email is required");
                      }}
                      className="delivery-minimal-input"
                    />
                    {emailError && <p style={errText}>{emailError}</p>}
                  </div>

                  {/* Phone */}
                  <div className="delivery-form-group">
                    <Form.Control
                      type="tel"
                      placeholder="Phone number (0300-1234567)"
                      value={phone}
                      style={phoneError ? errBorder : undefined}
                      onChange={(e) => {
                        setPhone(e.target.value);
                        setPhoneError(e.target.value ? (regExpChecker("phoneNumber", e.target.value) || "") : "Phone number is required");
                      }}
                      className="delivery-minimal-input"
                    />
                    {phoneError && <p style={errText}>{phoneError}</p>}
                  </div>

                  {/* City — same-city/intercity job-matching ke liye zaroori,
                      is field ke bina backend "city" column mein kabhi kuch
                      save hi nahi hota tha ── */}
                  <div className="delivery-form-group">
                    <Form.Select
                      value={city}
                      style={cityError ? errBorder : undefined}
                      onChange={(e) => {
                        setCity(e.target.value);
                        setCityError(e.target.value ? "" : "Please select your city");
                      }}
                      className="delivery-minimal-input"
                    >
                      <option value="">Select your city</option>
                      {PAKISTAN_CITIES.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </Form.Select>
                    {cityError && <p style={errText}>{cityError}</p>}
                  </div>

                  {/* Password */}
                  <div className="delivery-form-group">
                    <div className="delivery-password-wrapper">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        style={passwordError ? errBorder : undefined}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          if (!e.target.value) setPasswordError("Password is required");
                          else setPasswordError(regExpChecker("password", e.target.value) || "");
                          if (confirmPass) {
                            setConfirmPassError(confirmPass === e.target.value ? "" : "Passwords do not match");
                          }
                        }}
                        className="delivery-minimal-input"
                      />
                      <button
                        type="button"
                        className="delivery-password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    {passwordError && <p style={errText}>{passwordError}</p>}
                  </div>

                  {/* Error Message */}
                  {errorMessage && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "0.875rem",
                        marginBottom: "0.5rem",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )}

                  {/* Submit */}
                  <Button
                    type="submit"
                    className="delivery-submit-btn"
                    disabled={loading}
                  >
                    Send Verification Code
                  </Button>

                  <p className="delivery-terms-text">
                    By registering, you agree to our{" "}
                    <a href="#terms" className="delivery-terms-link">
                      Terms of Service
                    </a>{" "}
                    and{" "}
                    <a href="#privacy" className="delivery-terms-link">
                      Privacy Policy
                    </a>
                  </p>
                </>
              ) : (
                <>
                  {/* OTP */}
                  <div className="delivery-form-group">
                    <Form.Control
                      type="text"
                      placeholder="6-digit code"
                      value={otp}
                      style={otpError ? errBorder : undefined}
                      onChange={(e) => setOtp(e.target.value)}
                      className="delivery-minimal-input"
                    />
                    {otpError && <p style={errText}>{otpError}</p>}
                  </div>

                  {errorMessage && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "0.875rem",
                        marginBottom: "0.5rem",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )}

                  {/* Submit */}
                  <Button
                    type="submit"
                    className="delivery-submit-btn"
                    disabled={loading}
                  >
                    Verify &amp; Create Account
                  </Button>

                  <p className="delivery-terms-text">
                    Didn't receive the code?{" "}
                    <span
                      onClick={() => !resending && resendOtp()}
                      style={{
                        color: "#097d43",
                        fontWeight: 600,
                        cursor: resending ? "default" : "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {resending ? "Resending..." : "Resend"}
                    </span>
                  </p>

                  <button
                    type="button"
                    onClick={() => {
                      setStep(1);
                      setOtp("");
                      setOtpError("");
                      setErrorMessage("");
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#097d43",
                      marginTop: "0.25rem",
                      fontSize: "0.875rem",
                    }}
                  >
                    ← Edit details
                  </button>
                </>
              )}
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeliveryRegister;
